/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var JewelCrownIcon20Solid = forwardRef('JewelCrownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.525 2.422A.663.663 0 0 0 10 2.174a.663.663 0 0 0-.525.248l-2.83 3.66-3.96-2.612a.697.697 0 0 0-.706-.029.564.564 0 0 0-.306.578l1.145 7.486c.132.861.945 1.503 1.905 1.503h10.531c.958 0 1.77-.639 1.904-1.498l1.169-7.49a.564.564 0 0 0-.305-.578.697.697 0 0 0-.707.028l-3.96 2.613-2.83-3.661Z" }),
        React.createElement("path", { d: "M4.167 14.5a1.25 1.25 0 1 0 0 2.5h11.666a1.25 1.25 0 1 0 0-2.5H4.167Z" })));
});
